import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerStock = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [products, setProducts] = useState([]);
  const [updated, setUpdated] = useState('');
  const [stockMap, setStockMap] = useState({});

  const fetchData = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const updatedParam = params.get('updated') || '';

      const res = await axios.get(
        `/api/seller/stock-data${updatedParam ? `?updated=${encodeURIComponent(updatedParam)}` : ''}`,
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setShopName(res.data.shop_name || '');
        setProducts(Array.isArray(res.data.products) ? res.data.products : []);
        setUpdated(res.data.updated || '');

        const nextStockMap = {};
        (Array.isArray(res.data.products) ? res.data.products : []).forEach((row) => {
          nextStockMap[row.id] = row.stock ?? 0;
        });
        setStockMap(nextStockMap);
      } else {
        alert(res.data?.error || '재고 목록을 불러오지 못했습니다.');
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;
      const error = err?.response?.data?.error;

      if (redirect) {
        window.location.href = redirect;
        return;
      }

      alert(error || '재고 목록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleStockChange = (productId, value) => {
    setStockMap((prev) => ({
      ...prev,
      [productId]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        '/api/seller/stock-update',
        { stock: stockMap },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        window.location.href = res.data.redirect || '/seller/stock?updated=1';
        return;
      }

      alert(res.data?.error || '재고 수정에 실패했습니다.');
    } catch (err) {
      alert(err?.response?.data?.error || '재고 수정에 실패했습니다.');
    }
  };

  const makeImageSrc = (path) => {
    if (!path) return '';
    return `/static/${String(path).replace(/^\/+/, '')}`;
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <h2 style={styles.title}>재고 관리 ({shopName})</h2>

      {updated ? (
        <div style={styles.successAlert}>재고가 성공적으로 수정되었습니다.</div>
      ) : null}

      <div style={styles.tableContainer}>
        <form onSubmit={handleSubmit}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>썸네일</th>
                <th style={styles.th}>상품명</th>
                <th style={styles.th}>재고</th>
              </tr>
            </thead>
            <tbody>
              {products.map((row) => (
                <tr key={row.id}>
                  <td style={styles.td}>{row.id}</td>

                  <td style={styles.td}>
                    {row.display_image ? (
                      <img
                        src={makeImageSrc(row.display_image)}
                        alt=""
                        style={styles.thumb}
                      />
                    ) : (
                      '-'
                    )}
                  </td>

                  <td style={styles.td}>{row.name}</td>

                  <td style={styles.td}>
                    <input
                      type="number"
                      name={`stock[${row.id}]`}
                      value={stockMap[row.id] ?? 0}
                      min="0"
                      onChange={(e) => handleStockChange(row.id, e.target.value)}
                      style={styles.stockInput}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={styles.buttonRow}>
            <button type="submit" style={styles.submitButton}>
              재고 수정
            </button>
          </div>
        </form>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loadingWrap: {
    padding: '40px 0',
  },
  title: {
    marginTop: '20px',
    marginBottom: '30px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },
  successAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    background: '#d1e7dd',
    color: '#0f5132',
    border: '1px solid #badbcc',
    borderRadius: '6px',
  },
  tableContainer: {
    backgroundColor: '#ffffff',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    verticalAlign: 'middle',
    fontWeight: 600,
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
  },
  thumb: {
    width: '50px',
    height: 'auto',
  },
  stockInput: {
    width: '100%',
    maxWidth: '120px',
    padding: '8px 10px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  buttonRow: {
    textAlign: 'right',
    marginTop: '16px',
  },
  submitButton: {
    background: '#0d6efd',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 16px',
    cursor: 'pointer',
  },
};

export default SellerStock;